import * as React from 'react'

const IconPlayableAds = (isActive?, className?: string) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             className={className ? className : ''} width="69" height="69" viewBox="0 0 69 69">
            <g fill="none" fillRule="evenodd" stroke={isActive ? '#ff6262' : '#4A4A83'} strokeWidth=".961">
                <path d="M50.846 48.972l-16.788-9.7v19.39l16.788 9.699V48.97zM50.864 48.97l16.789-9.698V58.66l-16.789 9.7z"/>
                <path d="M34.076 19.905l16.788-9.7v19.39l-16.788 9.699z"/>
                <path d="M50.84 29.583l16.792 9.694-16.794 9.69-16.79-9.695zM34.077.48l16.79 9.695-16.793 9.69-16.791-9.695zM17.275 10.197l-.004 19.385-16.79-9.695z"/>
                <path d="M34.058 39.28l-16.789-9.7v19.389l16.789 9.7zM34.058 19.883l-16.789-9.698v19.389l16.789 9.698z"/>
                <path d="M17.27 29.586l-16.79-9.7v19.39l16.79 9.7z"/>
            </g>
        </svg>
    )
}

export default IconPlayableAds


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/svg/iconPlayableAds.tsx